import pluralize from 'pluralize'
import { faRobot, faObjectsColumn } from '@fortawesome/pro-solid-svg-icons'
import { sortData, capitalizarPrimeraLetra } from './index'

/**
 * This function return priority orden in menu
 * @param {String} key
 */
const getPriority = (key) => {
  if (key === 'home') {
    return 0
  }
  if (key === 'feed') {
    return 0.5
  }

  if (key === 'settings') {
    return 1
  }
  if (key === 'tenant') {
    return 1
  }
  if (key === 'role') {
    return 2
  }
  if (key === 'curriculum') {
    return 3
  }
  if (key === 'user') {
    return 4
  }
  if (key === 'level') {
    return 5
  }
  if (key === 'year') {
    return 6
  }
  if (key === 'period') {
    return 7
  }
  if (key === 'maintenance') {
    return 2
  }

  if (key === 'assessment') {
    return 2
  }
  if (key === 'class') {
    return 1.5
  }
  if (key === 'dr' || key === 'generator') {
    return 2
  }
  if (key === 'lc' || key === 'analytics') {
    return 3
  }
  if (key === 'audit' || key === 'subject') {
    return 4
  }
  if (key === 'photo-management') {
    return 8
  }

  if (key === 'periodical report') {
    return 2
  }
  if (key === 'periodical-report-setting') {
    return 1
  }
  if (key === 'periodical-report-generator') {
    return 2
  }
  if (key === 'periodical-report-marking') {
    return 3
  }

  //Data Entry
  if (key === 'dataentry') {
    return 3
  }

  if (key === 'templateassessmentgenerator') {
    return 1
  }

  if (key === 'dataentryassessment') {
    return 2
  }

  if (key === 'templatesurveygenerator') {
    return 3
  }

  if (key === 'dataentrysurveys') {
    return 4
  }

  if (key === 'dataentrymyassessments') {
    return 5
  }

  if (key === 'dataentrymysurveys') {
    return 6
  }

  //Journal (MF-67)
  if (key === 'journal') {
    return 3.6
  }
  if (key === 'journalentries') {
    return 1
  }
  if (key === 'journalconfiguration') {
    return 2
  }

  return 100
}

/**
 * This function return icon in option menu
 * @param {String} key
 */
const getIcon = (key) => {
  if (key === 'assessment') {
    return 'tasks'
  }
  if (key === 'settings') {
    return 'cogs'
  }
  if (key === 'class') {
    return 'users-class'
  }
  if (key === 'user') {
    return 'user'
  }
  if (key === 'role') {
    return ['far', 'users-cog']
  }
  if (key === 'generator') {
    return 'dice-d6'
  }
  if (key === 'home') {
    return 'home'
  }
  if (key === 'analytics') {
    return 'chart-line'
  }
  if (key === 'analytics-icon') {
    return 'project-diagram'
  }
  if (key === 'audit') {
    return 'list'
  }
  if (key === 'curriculum') {
    return ['far', 'file-certificate']
  }
  if (key === 'tenant') {
    return ['fal', 'university']
  }
  if (key === 'year') {
    return 'sort-numeric-up'
  }
  if (key === 'level') {
    return 'sort-amount-up'
  }
  if (key === 'period') {
    return 'exchange'
  }

  if (key === 'periodical-report') {
    return 'list-check'
  }

  //Data Entry Module
  if (key === 'dataentry') {
    return 'file'
  }
  if (
    key === 'dataentryassessment' ||
    key === 'templateassessmentgenerator' ||
    key === 'dataentrymyassessments'
  ) {
    return ['fal', 'rectangle-list']
  }
  if (key === 'dataentrysurveys' || key === 'templatesurveygenerator' || key === 'dataentrymysurveys') {
    return ['fas', 'globe']
  }

  if (key === 'photo-management') {
    return ['fas', 'images']
  }

  //Journal Module (MF-67)
  if (key === 'journal') {
    return 'book'
  }
  if (key === 'journalentries') {
    return ['fal', 'rectangle-list']
  }
  if (key === 'journalconfiguration') {
    return ['fal', 'sliders-h']
  }

  if (key === 'maintenance') {
    return ['far', 'pen-ruler']
  }
  return 'badge-check'
}

const getInfoAnalytics = (str) => {
  const data = str.split('_')
  let position = data[0]
  let code = data[1]
  let engine = data[2]
  return {
    position,
    code,
    engine
  }
}

const getLabel = (key = '') => {
  let label = String(key).trim().toLowerCase().split('-').join(' ')

  if (label === 'vic') {
    label = 'VIC curriculum achievement standards'
  }
  if (label === 'lc') {
    label = 'Learning continua'
  }

  if (label === 'dr') {
    label = 'Developmental rubric'
  }

  if (label === 'periodical report') {
    label = 'periodical report'
  }
  if (label === 'periodical report generator') {
    label = 'generator'
  }
  if (label === 'periodical report marking') {
    label = 'marking'
  }
  if (label === 'periodical report setting') {
    label = 'setting'
  }

  if (
    ![
      'marking',
      'curriculum',
      'Learning continua',
      'generator',
      'periodical report',
      'photo management',
      'setting'
    ].includes(label)
  ) {
    label = pluralize(label)
  }

  //Data Entry
  if (label === 'dataentry') {
    label = 'Data Entry'
  }

  if (key === 'templateassessmentgenerator') {
    label = 'Assessment Templates'
  }

  if (key === 'templatesurveygenerator') {
    label = 'Survey Templates'
  }

  if (key === 'dataentrysurveys') {
    label = 'Surveys'
  }

  if (key === 'dataentryassessment') {
    label = 'Assessments'
  }

  if (key === 'dataentrymysurveys') {
    label = 'My Surveys'
  }

  if (key === 'dataentrymyassessments') {
    label = 'My Assessments'
  }

  //Journal (MF-67)
  if (key === 'journal') {
    label = 'Journal'
  }
  if (key === 'journalentries') {
    label = 'Entries'
  }
  if (key === 'journalconfiguration') {
    label = 'Configuration'
  }

  return `${capitalizarPrimeraLetra(label)}`
}

// MF-67 — Journal configuration screens (tabs of the Configuration page).
const JOURNAL_CONFIG_KEYS = [
  'journaltypes',
  'journalseverities',
  'journalzones',
  'journalcategories',
  'journaltemplates'
]

const getPathRedirect = (key = '') => {
  let label = String(key).toLowerCase()

  if (label === 'lc') {
    label = 'learning-continuum'
  }

  if (label === 'dr') {
    label = 'developmental-rubric'
  }

  if (label === 'periodical-report-generator') {
    label = 'periodical-report/generator'
  }
  if (label === 'periodical-report-marking') {
    label = 'periodical-report/marking'
  }
  if (label === 'periodical-report-setting') {
    label = 'periodical-report/setting'
  }

  if (
    ![
      'learning-continuum',
      'curriculum',
      'periodical-report/generator',
      'periodical-report/marking',
      'periodical-report/setting',
      'periodical-report'
    ].includes(label)
  ) {
    label = pluralize(label)
  }

  //Data Entry
  if (key === 'templateassessmentgenerator') {
    label = 'data-entry/generator/assessment-templates'
  }

  if (key === 'templatesurveygenerator') {
    label = 'data-entry/generator/survey-templates'
  }

  if (key === 'dataentrysurveys') {
    label = 'data-entry/surveys'
  }

  if (key === 'dataentryassessment') {
    label = 'data-entry/assessments'
  }

  if (key === 'dataentrymysurveys') {
    label = 'data-entry/my-surveys'
  }

  if (key === 'dataentrymyassessments') {
    label = 'data-entry/my-assessments'
  }

  //Journal (MF-67)
  if (key === 'journalentries') {
    label = 'journal/entries'
  }
  if (key === 'journalconfiguration') {
    label = 'journal/configuration'
  }

  return label
}

const mapItemsMenu = (permissions, idRedirect, user = {}, licenses = [], featureFlag = {}) => {
  let items = [
    {
      id: 'home',
      label: 'Home',
      redirectTo: `/dashboard${idRedirect}`,
      icon: getIcon('home'),
      priority: -100
    }
  ]
  const { notifications } = user

  Object.keys(permissions).forEach((key) => {
    // MF-506 — AI Analyst. Item data-driven: aparece si el rol tiene el módulo 'AI-Analyst'
    // (clave 'ai-analyst'). Ruta dedicada, gateada por el mismo permiso. No se hardcodea rol.
    if (key === 'ai-analyst') {
      items.push({
        id: 'ai-analyst',
        label: 'AI Analyst',
        redirectTo: `/dashboard${idRedirect}/analytics/ai-analyst`,
        // Pasamos el OBJETO del ícono (no el string): FontAwesomeIcon lo pinta directo, sin
        // depender del registro en library.add ni de aliases. faRobot no tiene alias, y el menú
        // se cachea en redux-persist (hardSet), así que el objeto es la vía robusta.
        icon: faRobot,
        priority: 0.6
      })
    }
    // MF-554 — Board Builder (license `boards`, module BoardsBuilder): build and publish Boards. It is a
    // tool, not a chart: first in the Analytics group, with a divider before the charts (and the
    // published Boards, which show up there as their own buttons).
    if (key === 'boardsbuilder') {
      items.push({
        group: 'analytics',
        id: 'board-builder',
        label: 'Board Builder',
        redirectTo: `/dashboard${idRedirect}/analytics/board-builder`,
        icon: faObjectsColumn,
        priority: getPriority('analytics') - 1
      })
    }
    if (key === 'feed' && featureFlag?.showFeed) {
      items.push({
        id: key,
        label: 'Feed',
        redirectTo: `/dashboard${idRedirect}/feed`,
        icon: 'rss',
        priority: getPriority(key)
      })
    }
    if (['classes-maintenance', 'users-maintenance'].includes(key)) {
      const find = items.find((el) => el.id === 'maintenance')
      if (!find) {
        items.push({
          group: 'settings',
          id: 'maintenance',
          label: 'Maintenance',
          redirectTo: `/dashboard${idRedirect}/maintenance`,
          icon: getIcon('maintenance'),
          priority: getPriority('maintenance')
        })
      }
    }

    if (['lc', 'dr', 'subject'].includes(key)) {
      const findAssesment = licenses.find((el) => el.code === 'assessment')
      if (findAssesment) {
        items.push({
          group: 'assessment',

          className: 'color-secondary-blue',
          id: key,
          priority: getPriority(key),
          redirectTo: `/dashboard${idRedirect}/${getPathRedirect(key)}`,
          label: getLabel(key),
          icon: getIcon(key)
        })
      } else if (['subject'].includes(key)) {
        items.push({
          // group: 'assessment',

          className: 'color-secondary-blue',
          id: key,
          priority: 1.5,
          redirectTo: `/dashboard${idRedirect}/${getPathRedirect(key)}`,
          label: getLabel(key),
          icon: getIcon(key)
        })
      }
    }

    if (
      [
        'periodical-report-assessment-area',
        'periodical-report-type',
        'periodical-report-period',
        'periodical-report-marking',
        'periodical-report-generator',
        'periodical-report-setting'
      ].includes(key)
    ) {
      const find = items.find((item) => item.id === 'periodical-report')
      if (!find) {
        const nKey = 'periodical-report'
        items.push({
          group: 'assessment',

          className: 'color-secondary-blue',
          id: nKey,
          priority: getPriority(nKey),
          redirectTo: `/dashboard${idRedirect}/${getPathRedirect(nKey)}`,
          label: getLabel(nKey),
          icon: getIcon(nKey)
        })
      }
    }

    if (key === 'analytics') {
      Object.keys(permissions[key]).forEach((el) => {
        const { position, code, engine } = getInfoAnalytics(el)
        items.push({
          group: key,
          id: el,
          label: el,
          redirectTo:
            engine === 'analytics-curriculum'
              ? `/dashboard${idRedirect}/${key}/${code}/analytics-curriculum`
              : `/dashboard${idRedirect}/${key}/${code}`,
          icon: 'project-diagram',
          priority: getPriority(key) + parseInt(position)
        })
      })
    }
    if (key === 'audit') {
      items.push({
        id: key,
        label: 'Audit',
        redirectTo: `/dashboard${idRedirect}/${key}`,
        icon: getIcon(key),
        priority: getPriority(key)
      })
    }

    if (['role', 'user'].includes(key)) {
      items.push({
        group: 'settings',

        className: 'color-secondary-blue',
        id: key,
        label: getLabel(key),
        priority: getPriority(key),
        redirectTo: `/dashboard${idRedirect}/${key}s`,
        icon: getIcon(key)
      })
    }

    if (['curriculum', 'photo-management'].includes(key)) {
      items.push({
        group: 'settings',

        className: 'color-secondary-blue',
        id: key,
        label: getLabel(key),
        priority: getPriority(key),
        //redirectTo: `/dashboard/${key}/list`,
        redirectTo: `/dashboard/${key}`,
        icon: getIcon(key)
      })
    }

    if (key === 'tenant') {
      items.push({
        group: 'settings',

        className: 'color-secondary-blue',
        id: key,
        priority: getPriority(key),
        redirectTo: `/dashboard/school`,
        label: `School`,
        icon: getIcon(key)
      })
    }

    if (key === 'class') {
      const hasAssessmentLicense = licenses.some((el) => el.code === 'assessment')
      const isAdminOrMaestro = user?.roles?.some((role) =>
        ['Administrator', 'Maestro'].includes(role.name || role.id)
      )
      // If no Assessment license, only show Classes to Administrator and Maestro
      if (hasAssessmentLicense || isAdminOrMaestro) {
        items.push({
          // group: 'settings',
          className: 'color-secondary-blue',
          id: key,
          priority: getPriority(key),
          redirectTo: `/dashboard${idRedirect}/${getPathRedirect(key)}`,
          label: getLabel(key),
          icon: getIcon(key)
        })
      }
    }

    //Data Entry
    if (
      idRedirect === '' &&
      [
        'dataentryassessment',
        'dataentrysurveys',
        'dataentrymysurveys',
        'dataentrymyassessments',
        'templateassessmentgenerator',
        'templatesurveygenerator'
      ].includes(key)
    ) {
      const priority = getPriority(key) + getPriority('dataentry')
      let showNotification = false
      let badgeContent = 0

      if (key === 'dataentrymysurveys') {
        // hide when backend explicitly says user has no surveys (hasMySurveys === false)
        if (notifications?.hasMySurveys === false) return
        showNotification = notifications?.mySurveys?.length > 0
        badgeContent = notifications?.mySurveys?.length ?? 0
      }

      if (key === 'dataentrymyassessments') {
        // hide when backend explicitly says user has no assessments (hasMyAssessments === false)
        if (notifications?.hasMyAssessments === false) return
        showNotification = notifications?.myAssessments?.length > 0
        badgeContent = notifications?.myAssessments?.length ?? 0
      }

      items.push({
        group: 'dataentry',
        className: 'color-secondary-blue',
        id: key,
        priority,
        redirectTo: `/dashboard${idRedirect}/${getPathRedirect(key)}`,
        label: getLabel(key),
        icon: getIcon(key),
        showNotification,
        badgeContent
      })
    }

    //Journal (MF-67) — grouped module in the botonera: "Entries" + one "Configuration" item that
    // opens the tabbed setup page when the role holds any of the config permissions.
    if (idRedirect === '' && (key === 'journalentries' || JOURNAL_CONFIG_KEYS.includes(key))) {
      const id = key === 'journalentries' ? key : 'journalconfiguration'
      if (!items.some((it) => it.id === id)) {
        items.push({
          group: 'journal',
          className: 'color-secondary-blue',
          id,
          priority: getPriority(id) + getPriority('journal'),
          redirectTo: `/dashboard${idRedirect}/${getPathRedirect(id)}`,
          label: getLabel(id),
          icon: getIcon(id)
        })
      }
    }
  })

  // MF-583 — Server health: internal, only for the Maestro role, and not a module anybody can be granted
  const isMaestro = (user?.roles || []).some((role) => (role.name || role.id) === 'Maestro')
  if (idRedirect === '' && isMaestro) {
    items.push({
      id: 'server-health',
      label: 'Server health',
      redirectTo: '/dashboard/server-health',
      icon: 'server',
      priority: 5 // right after Audit
    })
  }

  items = sortData(items, 'priority', 'acs', 'number')
  let general = []

  items.forEach((item) => {
    if (item.group) {
      if (!general.some((elem) => elem.id === item.group)) {
        general.push({
          id: item.group,
          label: capitalizarPrimeraLetra(item.group),
          icon: getIcon(item.group),
          priority: getPriority(item.group),
          items: items.sort((a, b) => a.priority - b.priority).filter((x) => x.group === item.group),
          showNotification: item?.showNotification ?? false,
          badgeContent: item?.badgeContent ?? 0
        })
      }
    } else {
      general.push(item)
    }
  })

  general = general.map((item) => {
    if (item.items) {
      let items = sortData(item.items, 'label', 'acs')
      if (item.id === 'analytics' || item.id === 'assessment' || item.id === 'periodical report') {
        items = sortData(item.items, 'priority', 'acs', 'number')
      }
      if (item.id === 'analytics' && items[0]?.id === 'board-builder' && items[1]) {
        items = [items[0], { ...items[1], divider: true }, ...items.slice(2)]
      }
      if (item.id === 'dataentry') {
        item.label = 'Data Entry'
        items = sortData(item.items, 'priority', 'acs', 'number')
      }
      if (item.id === 'journal') {
        item.label = 'Journal'
        items = sortData(item.items, 'priority', 'acs', 'number')
      }
      return { ...item, items }
    } else {
      return { ...item }
    }
  })
  return general
}

/**
 * This function generates options in the menu according to the user's permissions.
 * @param {String} key
 */
const generateItemsMenu = (permissions, user = {}, id, licenses = [], featureFlag = {}) => {
  let items = []

  const checkAssessment = licenses.some((license) => license._id === '61fc0f1d6bbfcac1a18f02ba')
  if (user.roles.some((role) => role.name === 'Parent') && checkAssessment) {
    items.push({
      id: 'dashboard',
      label: 'Students List',
      redirectTo: `/dashboard`,
      icon: 'home',
      priority: 1
    })

    if (id) {
      items = [...items, ...mapItemsMenu(permissions, id ? `/${id}` : '', user, licenses, featureFlag)]
    }

    if (permissions?.['dataentrymysurveys']) {
      const newPermissions = {
        dataentrymysurveys: permissions?.['dataentrymysurveys']
      }
      items = [...items, ...mapItemsMenu(newPermissions, '', user, licenses, featureFlag)]
    }
  } else {
    items = mapItemsMenu(permissions, '', user, licenses, featureFlag)
  }

  items = sortData(items, 'priority', 'acs', 'number')

  return items
}
export { generateItemsMenu }
